import { useEffect } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";

import * as API from 'api';
import * as Meta from 'meta';
import { isBuilding, loginFBLink, loginGoogleLink, gaEvent } from 'utils';
import { Footer, Header } from 'components';
import { ROUTE } from "route";

export const LoginPage = () => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const ishara = API.getToken();
    if(!ishara) return;
    fetch(API.user(true))
      .then(res => res.json())
      .then(json => {
        if(json === 'custom error') return;
        history.goBack();
      });
  }, []);

  const query = new URLSearchParams(location.search);

  return (
    <div className="wrapper">
      {Meta.loadCSS(['login', 'notice'])}
      {Meta.loadJS(['main-0625'])}
      {Meta.ga("登入頁")}
      <Header />
      <div className="main">
        <section className="login inner">
          <div className="page_text">請選擇登入方式</div>
          <div className="login_btbox">
            {!isBuilding() && <>
              <a href={loginFBLink(query.get('location'))} onClick={gaEvent.bind(null, '登入', 'FB登入')}>
                <button>
                  <img src="/resources/html/images/login/icons_fb.png" />
                  <span>Facebook</span>
                </button>
              </a>
              <a href={loginGoogleLink(location.search.replace('?location=', ''))} onClick={gaEvent.bind(null, '登入', 'Google登入')}>
                <button>
                  <img src="/resources/html/images/login/icons_google.png" />
                  <span>Google</span>
                </button>
              </a>
              <Link to={`${ROUTE.LOGINOTHER}${location.search}`} className="login_other">若是沒有FB、Gmail帳號請點此處</Link>
            </>}
          </div>
        </section>
        <img className="login_left" src="/resources/html/images/intro/intro_left.png" />
        <img className="login_right" src="/resources/html/images/intro/intro_right.png" />
        <div className="other o1 ml"><img src="/resources/html/images/index/kv_p1.png" /></div>
        <div className="other o2 mr"><img src="/resources/html/images/index/kv_p2.png" /></div>
        <div className="fwave fw1 ml"><img src="/resources/html/images/login/wave01.png" /></div>
        <div className="fwave fw2 mr"><img src="/resources/html/images/login/wave02.png" /></div>
        <div className="fwave fw3 ml"><img src="/resources/html/images/login/wave03.png" /></div>
        <div className="fwave fw4 mr"><img src="/resources/html/images/login/wave04.png" /></div>
      </div>

      <Footer />
      <div className="scroll_top"><span>TOP</span></div>
    </div>
  );
};
